import React, { useState, useEffect } from 'react';
import { Container, Row, Spinner } from 'reactstrap';
import { useParams, Link } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Overview from './Overview';
import DetailsSection from './DetailsSection';

const JobDetails = () => {
    document.title = "Taşıma Detayları | LojGo";
    
    // useParams ile URL'den gelen id'yi yakalıyoruz. (Örn: /jobs/1136820)
    const { id } = useParams(); 
    // const id = "1136820"; // Test için bunu kullanabilirsiniz, useParams'ı yoruma alın

    const [tripDetail, setTripDetail] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // OData API'den Veri Çekme
    useEffect(() => {
        const fetchAdvertDetails = async () => {
            setIsLoading(true);
            try {
                // API'ye istek atarken id'yi dinamik kullanıyoruz
                const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert(${id})?$expand=Users_Car,Advert_Location`);
                
                if (!response.ok) {
                    throw new Error("Veri çekilemedi");
                }
                
                const result = await response.json();

                if (result) {
                    const car = result.Users_Car || {};
                    // API'den gelen veriye göre array veya object olabilir, kontrol edelim.
                    const location = Array.isArray(result.Advert_Location) ? result.Advert_Location[0] : (result.Advert_Location || {});

                    setTripDetail({
                        id: result.ID,
                        distance: location.Km ? `${location.Km} km` : "-",
                        duration: result.Estimated_Duration || "00:00",
                        start: {
                            city: `${location.Start_City_Code || ''} ${location.Advert_Location_StartAddress?.split(',')[0] || ''}`,
                            date: result.Advert_DateTime ? new Date(result.Advert_DateTime).toLocaleString('tr-TR') : "-",
                            address: location.Advert_Location_StartAddress || "-",
                            countryFlag: "🇪🇺" 
                        },
                        end: {
                            city: `${location.Finish_City_Code || ''} ${location.Advert_Location_FinishAddress?.split(',')[0] || ''}`,
                            date: result.Advert_DateTime2 ? new Date(result.Advert_DateTime2).toLocaleString('tr-TR') : "-",
                            address: location.Advert_Location_FinishAddress || "-",
                            countryFlag: "🇪🇺"
                        },
                        vehicle: {
                            brand: car.Users_Car_Brand || "-",
                            model: car.Users_Car_Model || "-",
                            engine: car.Engine_Type || "-",
                            fuelType: result.Fuel_Status || "Bilgi yok",
                            instructions: result.Customer_Notes || "Araca yakıt koymayın."
                        },
                        services: [
                            "Geri dönmeden önce yolculuğun sonunda beklemek",
                            "Profesyonel sürücü talep edildi"
                        ],
                        procedure: "Teslimat Belçika - Git",
                        comments: "Müşteri yorumu yok",
                        customerInstructions: "Burada ayrıntılı olarak açıklanan sürece bağlantı"
                    });
                }
            } catch (error) {
                console.error("Detaylar çekilirken hata:", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchAdvertDetails();
        }
    }, [id]);

    return (
        <React.Fragment>
             <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Uygun Geziler" breadcrumbItem="Taşıma Detayları" />

                    <div className="d-flex align-items-center mb-4">
                        <Link to="/job-list" className="text-dark me-3">
                            <i className="mdi mdi-arrow-left fs-3"></i>
                        </Link>
                        <h3 className="mb-0">Taşıma detayları n°{id}</h3>
                    </div>

                    {isLoading ? (
                        <div className="text-center py-5">
                            <Spinner color="primary" /> <p className="mt-2">Detaylar yükleniyor...</p>
                        </div>
                    ) : tripDetail ? (
                        <Row>
                            {/* Sol Tarafa Geniş Alan, Sağ Tarafa Dar Alan */}
                            <DetailsSection detail={tripDetail} />
                            <Overview detail={tripDetail} />
                        </Row>
                    ) : (
                        <div className="alert alert-danger">Kayıt bulunamadı veya bir hata oluştu.</div>
                    )}
                </Container>
            </div>
        </React.Fragment>
    );
}

export default JobDetails;